import React from "react";

const PriceSelector = ({ selectedProductObj, selectedPrice, handlePriceChange, errors }) => (
  <div className="mb-4">
    <label
      className="block text-gray-700 text-sm font-bold mb-2"
      htmlFor="stripePrice"
    >
      Stripe Price
    </label>
    <select
      id="stripePrice"
      value={selectedPrice}
      onChange={handlePriceChange}
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
    >
      <option value="">Select a price</option>
      {selectedProductObj?.product.prices.map((price) => (
        <option key={price.id} value={price.id}>
          {price.unit_amount} {price.currency.toUpperCase()} /{" "}
          {price.recurring.interval_count}{" "}
          {price.recurring.interval}
        </option>
      ))}
    </select>
    {errors.stripe_price && (
      <p className="text-red-600 text-sm">
        {errors.stripe_price.message}
      </p>
    )}
  </div>
);

export default PriceSelector; 